import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFormate'
})
export class DateFormatePipe implements PipeTransform {

  transform(DateData: Date): any {
    var DataString = "";
    if (DateData != null) {
      var shortDate = DateData.toString().replace("T", " ").replace("-", "/").replace("-", "/");
      var dotIndex = shortDate.indexOf('.');

      var DataFormate = new Date(shortDate.slice(0, dotIndex));

      var year = DataFormate.getFullYear();
      var month = DataFormate.getMonth() + 1;  //月份是0-11月 所以要補1
      var date = DataFormate.getDate();

      DataString = "民國" + (year - 1911) + "年" + month + "月" + date + "日";

    }
    return DataString;
  }

}

// @Pipe({
//   name: 'dateFormateFull'
// })
// export class DateFormateFullPipe implements PipeTransform {

//   transform(DateData: Date): any {
//     var DataString = "";
//     if (DateData != null) {
//       var shortDate = DateData.toString().replace("T", " ").replace("-", "/").replace("-", "/");
//       var dotIndex = shortDate.indexOf('.');

//       var DataFormate = new Date(shortDate.slice(0, dotIndex));
//       var time = "上午";
//       var year = DataFormate.getFullYear();
//       var month = DataFormate.getMonth() + 1;  //月份是0-11月 所以要補1
//       var date = DataFormate.getDate();
//       var hour = DataFormate.getHours();
//       var min = DataFormate.getMinutes();
//       if (hour > 12) {
//         time = "下午";
//       }
//       DataString = "民國" + (year - 1911) + "年" + month + "月" + date + "日" + time + hour + "時" + min + "分";

//     }
//     return DataString;
//   }

// }
@Pipe({ name: 'DateFormateTwo' })
export class DateFormateTwo implements PipeTransform {
  transform(DateData: string) {
    var DataString = "";
    if (DateData != null) {
      var DataFormate = new Date(DateData.replace("T", " ").replace("-", "/").replace("-", "/"));
      var year = DataFormate.getFullYear();
      var month = DataFormate.getMonth() + 1;  //月份是0-11月 所以要補1
      var date = DataFormate.getDate();
      var hour = DataFormate.getHours();
      var min = DataFormate.getMinutes();
      var Sec = DataFormate.getSeconds();
      DataString = "民國" + (year - 1911) + "年" + month + "月" + date + "日" + "  " + hour + ":" + min + ":" + Sec;
    }
    return DataString;
  }
}

@Pipe({ name: 'IDFilter' })
export class IDFilter implements PipeTransform {
  transform(ID: string) {
    var IDString = "";
    console.log(ID)
    console.log(ID.trim().length);
    if (ID != null) {
      for (var i = 0; i <= ID.trim().length; i++) {

        if (i < (ID.trim().length / 2)) {
          IDString += "*";
        } else {
          IDString += ID.substr(i, 1);
        }
        console.log(IDString);
      }
    }
    return IDString;
  }
}
